import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { client } from '../../../../api/client';
import { BASE_URL } from '../../../../config';

const initialState = {
  status: 'idle',
  error: null,
  planCode: 'free-plan',
  planName: 'Free Plan',
  componentsLimit: null,
  seatsTotal: null,
  seatsUsed: null,
};

export const fetchSubscriptionStatus = createAsyncThunk(
  'subscription/fetchStatus',
  async (_, { rejectWithValue }) => {
    try {
      const response = await client.get(`${BASE_URL}/subscription/status`);
      return response;
    } catch (err) {
      return rejectWithValue(err?.data || { message: err.message });
    }
  }
);

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setComponentsLimit(state, action) {
      state.componentsLimit = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionStatus.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSubscriptionStatus.fulfilled, (state, action) => {
        const payload = action.payload || {};
        state.status = 'succeeded';
        state.planCode = payload.plan_code || payload.planCode || state.planCode;
        state.planName = payload.plan_name || payload.planName || state.planName;
        state.componentsLimit = null;
        state.seatsTotal = payload.seats_total ?? payload.seatsTotal ?? state.seatsTotal;
        state.seatsUsed = payload.seats_used ?? payload.seatsUsed ?? state.seatsUsed;
      })
      .addCase(fetchSubscriptionStatus.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.message || 'No se pudo obtener la suscripción.';
      });
  },
});

export const { setComponentsLimit } = subscriptionSlice.actions;

export const selectSubscription = (state) => state.subscription || initialState;

export default subscriptionSlice.reducer;
